import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Phone } from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const ConsumerCTA = () => {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section ref={ref} className="py-20 px-4">
      <div className="container mx-auto text-center max-w-3xl">
        <div className={`transition-all duration-700 ${isVisible ? 'animate-scale-in' : 'opacity-0 scale-95'}`}>
          <h2 className="text-4xl font-bold mb-6">
            Ready to Get Started?
          </h2>
          <p className="text-xl text-gray-300 mb-8">
            Get free professional marketing for your property and connect with serious cash buyers. 
            No fees, no obligations, no hassle.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-6">
            <Link to="/consumer/get-started">
              <Button size="lg" className="bg-[#ffd700] text-[#080c14] hover:bg-[#e6c200] px-8 hover-lift group w-full sm:w-auto">
                Get Started
                <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
              </Button>
            </Link>
            <Link to="/contact">
              <Button 
                size="lg" 
                variant="outline" 
                className="border-gray-600 text-white hover:bg-gray-800 w-full sm:w-auto"
              >
                <Phone className="mr-2 h-5 w-5" />
                Request a Call
              </Button>
            </Link>
          </div>
          
          <p className="text-sm text-gray-400">
            Free consultation • No setup fees • Response within 24 hours
          </p>
        </div>
      </div>
    </section>
  );
};

export default ConsumerCTA;
